import { Route } from "@lifeat/shared/system/RouteConstants";

export const isProductionRoute = () => {
    return window.location.origin === "https://lifeat.io";
};

export const getQueryParams = (loc?: string) => {
    return loc ? new URLSearchParams(loc) : new URLSearchParams(location.search);
};

export const getQueryParamsStr = (loc?: string) => {
    return getQueryParams(loc).toString();
};

export const queryParamPresent = (param: string, loc?: string) => {
    return getQueryParams(loc).has(param);
};

export const getQueryParamValue = (param: string) => {
    const qp = getQueryParams();
    if (qp.has(param)) {
        return qp.get(param);
    } else {
        return undefined;
    }
};

/**
 * Builds a query string from a map of params
 * @param paramMap map of query param names to values
 * @deprecated Use appendQueryParams instead
 */
export const buildQueryParamsString = (paramMap: Record<string, unknown>) => {
    const paramVals: string[] = Object.entries(paramMap).map(([paramName, paramVal]) => {
        if (paramName && paramVal) {
            return `${paramName}=${paramVal}`;
        }
        return undefined;
    });

    return `?${paramVals.filter((element) => element != null).join("&")}`;
};

export const updateQueryParams = (paramName: string, paramVal: string | null | undefined) => {
    const p = new URLSearchParams(window.location.search);
    if (paramVal == null) {
        p.delete(paramName);
    } else {
        p.set(paramName, paramVal);
    }
    return p.toString();
};

type RoutePart =
    | Route // predefined routes
    | `:${string}`; // for dynamic routes

export const buildRoute = (...routes: RoutePart[]): string => {
    return "/" + routes.join("/");
};

export const addQueryParams = (link: string, queryParams: Record<string, string>): string => {
    const urlObject = new URL(link);
    Object.keys(queryParams).forEach((key) => {
        urlObject.searchParams.set(key, queryParams[key].toString());
    });
    return urlObject.toString();
};
